<template>
    <div class="garlans-slider">
        <b-container>
            <b-row>
                <b-col lg="7">
                  <div class="txt-header">
                        <span>Puedes usar tu <span class="text-gold">Tarjeta Garlan's</span>
                           en
                        </span>
                        <span class="black-bg">tienda y en línea</span>
                    </div>
                    <p>¡Lúcete con las mejores marcas de moda!</p>
                    <b-row>
                        <div class="marquee-wrapper">
                            <div class="container">
                                <div class="marquee-block">
                                    <div class="marquee-inner to-left">
                                        <span>
                                            <div v-for="i in 19" :key="i" class="marquee-item">
                                                <img :src="require('../assets/img/icn_brand'+i+'.svg')" />
                                            </div>
                                        </span>
                                        <span>
                                            <div v-for="i in 19" :key="i" class="marquee-item">
                                                <img :src="require('../assets/img/icn_brand'+i+'.svg')" />
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-row>
                </b-col>
                <b-col lg="5" class="align-self-center">
                    <b-row class="mb-4">
                      <a class="btn-black" href="https://apply.garlans.com/">Aplica hoy</a>
                    </b-row>
                    <b-row>
                      <a class="btn-white" href="https://www.garlans.com/">Ir a tienda</a>
                    </b-row>
                    <img class="img-girl" src="../assets/img/img_girl_brands.png">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

.garlans-slider{
    width: 100%;
    background-image: url('../assets/img/img_banner_brands.jpg') ;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 5% 0;
    position: relative;
    overflow: hidden;
}
.btn-black,
.btn-black:focus,
.btn-black:hover{
    color: #fff;
    background: #000;
    text-align: center;
    text-decoration: none;
    padding: 12px 40px;
    font-weight: bold;
    font-size: 25px;
    max-width: 400px;
}
.btn-white,
.btn-white:focus,
.btn-white:hover{
    color: #000;
    background: #fff;
    text-align: center;
    text-decoration: none;
    padding: 12px 40px;
    font-weight: bold;
    font-size: 25px;
    max-width: 400px;
} 
p{
  color: #fff;
  font-size: 35px;
  font-family: futura-pt, sans-serif;
}
.img-girl{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 30%;
}
.txt-header{
    font-family: futura-pt, sans-serif;
    font-weight: 400;
    font-style: normal;
    color: #fff;
    font-size: 60px;
    line-height: 1.1;
    width: 90%;
}
.text-gold{
    color:#F7D85C;
    font-weight: 600;
}
.black-bg{
    background: #000;
    padding: 0 5px;
    font-weight: 600;
}
.marquee-wrapper{
  text-align:center;
  width: 90%;
}
.marquee-wrapper .container{
  overflow:hidden;
}
.marquee-inner span{
  float:left;
  width:50%;
}
.marquee-wrapper .marquee-block{
  --total-marquee-items:19;
  height: 100px;
  width: calc(124px * (var(--total-marquee-items)));
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  margin: 20px auto;
  padding: 30px 0;
}
.marquee-inner{
  display: block;
  width: 200%;
  position: absolute;
}
.marquee-inner p{
  font-weight: 800;
  font-size: 30px;
  font-family: cursive;
}
.marquee-inner.to-left{
  animation: marqueeLeft 100s linear infinite;
}
.marquee-inner.to-right{
  animation: marqueeRight 40s linear infinite;
}
.marquee-item{
  width: fit-content;
  height: auto;
  display: inline-block;
  margin: 0 10px;
  float: left;
  transition: all .6s ease-out;
}
.marquee-item > img{
    height: 40px !important;
}
@keyframes marqueeLeft{
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
@keyframes marqueeRight{
  0% { 
    left: -100%; 
  }
  100% {
   left: 0; 
  }
}

@media (max-width: 1600px) {
  .txt-header{
        font-size: 45px;
        line-height: 1.1;
  }
  p{
    font-size: 28px;
  }
  .btn-white,
  .btn-white:focus,
  .btn-white:hover,
  .btn-black,
  .btn-black:focus,
  .btn-black:hover{
    font-size: 16px;
    max-width: 50%;
  }
}

@media (max-width: 1300px) {
    .txt-header{
        font-size: 35px;
        line-height: 1.1;
    }
}

@media (max-width: 768px) {
    .txt-header{
      font-size: 29px;
      line-height: 1.1;
      width: 100%;
      margin-bottom: 10px;
    }
    .img-girl{
      display: none;
    }
    p{
      font-size: 22px;
    }
    .btn-white,
    .btn-white:focus,
    .btn-white:hover,
    .btn-black,
    .btn-black:focus,
    .btn-black:hover{
      max-width: 100%;
      font-size: 16px;
    }
    .garlans-slider{
        background-size: cover;
        padding: 10% 7%;
        position: relative;
    }
    .marquee-wrapper{
      width: 110%;
    }
    .marquee-wrapper .marquee-block{
      margin: -10px auto 10px auto;
    }
}

</style>